import { ShiftProfilesTable } from 'components/table/shift_profiles/Table';

const ShiftProfile = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <h1 style={{ margin: '0 0 16px 0' }}>Perfil de Turno</h1>
            <div style={{ flex: 1, minHeight: 0 }}>
                <ShiftProfilesTable />
            </div>
        </div>
    );
}

export { ShiftProfile };